import { Component, EventEmitter, Input, Output } from '@angular/core';
import { translationKeys } from '../../../core';
import { NGXLogger } from 'ngx-logger';

export interface DossierError {
  echaResponseErrorText?: string;
  echaResponseStatus?:
    | 'CLIENT_ERROR'
    | 'FAILED_AUTHENTICATION_CHECKS'
    | 'FAILED_AUTHORISATION_CHECKS'
    | 'SERVICE_NOT_FOUND'
    | 'REFUSED_REQUEST_UNSUPPORTED_FORMAT'
    | 'SERVER_ERROR'
    | 'NETWORK_ERROR_WHILE_SUBMITTING'
    | 'DOSSIER_FILE_CREATION_ERROR'
    | 'UNDEFINED_STATUS_CODE'
    | 'DOSSIER_SENT_TO_ECHA';
}

@Component({
  selector: 'scip-dossier-error-details-dialog',
  templateUrl: './dossier-error-details-dialog.component.html',
  styleUrls: ['./dossier-error-details-dialog.component.scss']
})
export class DossierErrorDetailsDialogComponent {
  @Input() header: string;
  @Input()
  set dossierError(val: DossierError) {
    // We display the technical as is, but we also parse it if possible
    this.unconvertedDossierError = val;
    this.parseError(val);
  }
  @Output() readonly closeDialog: EventEmitter<void> = new EventEmitter<void>();

  showDialog = true;
  translationKeys: typeof translationKeys = translationKeys;

  unconvertedDossierError: DossierError;

  errorDescription: string;

  constructor(private logger: NGXLogger) {}

  private parseError(unparsedError: DossierError): void {
    try {
      const parsedEchaResponseErrorText = JSON.parse(unparsedError.echaResponseErrorText);
      this.errorDescription = parsedEchaResponseErrorText.error_description;
    } catch (error) {
      this.logger.error('DossierErrorDetailsDialogComponent: Could not parse echaResponseErrorText for: ', unparsedError);
    }
  }
}
